import { FC } from "react";
import "./style.scss";
import { ReactComponent as TopUpIcon } from "../../../../assets/TopUpLiner.svg";
import Open from "../../../../assets/OpenPortfolio.svg";
import { ReactComponent as ChevronDownIcon } from "../../../../assets/ChevronDownPink.svg";
import { PATH_LIST } from "shared/lib/react-router";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { GetCurrByCode, GetCurrSymbol } from "helpers/currencies";
import { useVerificationNavigation } from "hooks/useNavigateVerification";
import { toast } from "react-toastify";
import useSubAccount from "hooks/useSubAccount";

type BalanceProps = {
  currency: string;
  amount: string | number;
  coupon?: {
    hidden: boolean;
    amount: number;
    date: string;
  };
  onClick?: () => void;
};

type PerformanceProps = {
  currency: string;
  amount: string | number | any;
  // daily: {
  //   isUp: boolean;
  //   amount: string | number;
  //   percent: string | number;
  // };
  allTime: {
    hidden: boolean;
    isUp: boolean;
    amount: string | number;
    percent: string | number;
  };
};

type TotalProps = {
  type: "balance" | "performance";
  onClick: () => void;
  selected: string;
  currency: string;
  amount: string | number;
  coupon?: {
    amount: number;
    date: string;
  };
  // daily?: {
  //   isUp: boolean;
  //   amount: string | number;
  //   percent: string | number;
  // };
  allTime?: {
    hidden: boolean;
    isUp: boolean;
    amount: string | number;
    percent: string | number;
  };
};

type BalanceWidgetProps =
  | { type: "balance"; data: BalanceProps }
  | { type: "performance"; data: PerformanceProps }
  | { type: "total"; data: TotalProps };

const BalanceWidget: FC<BalanceWidgetProps> = (props) => {
  const { t } = useTranslation("app");
  const navigate = useNavigate();
  const code = GetCurrSymbol(props.data.currency);
  const symbol = GetCurrByCode(props.data.currency);
  const { subAccount } = useSubAccount();
  const { status } = useVerificationNavigation();

  if (props.type === "balance") {
    return (
      <div
        className="balance-widget"
        style={{
          cursor: "pointer",
        }}
        onClick={props.data.onClick}
      >
        {!subAccount && (
          <TopUpIcon
            className="balance-widget-top-up"
            role="button"
            aria-label={t("topUpAccount")}
            onClick={(e) => {
              e.stopPropagation();
              status
                ? toast.info(t("verificationRequired"))
                : navigate(PATH_LIST.deposit, {
                    state: { currency: symbol?.code },
                  });
            }}
          />
        )}

        <span>
          {symbol?.code}
          {/* {t("available").toLowerCase()} */}
        </span>

        <p>
          {props.data.amount} {symbol?.symbol}
        </p>

        {props.data.coupon ? (
          // <span
          //   onClick={() => navigate(PATH_LIST.portfolio)}
          //   style={{ cursor: "pointer" }}
          // >
          //   {props.data.coupon.date} | +{props.data.coupon.amount}
          //   {symbol?.symbol}
          // </span>

          <span
            onClick={() => navigate(PATH_LIST.portfolio)}
            style={{ cursor: "pointer" }}
          >
            {props.data.coupon.date} {/* {"\u00A0"} */}
            {props.data.coupon.hidden ? `+${props.data.coupon.amount}` : "••• "}
            {symbol?.symbol}
          </span>
        ) : (
          <span
            // onClick={() =>
            //   navigate(PATH_LIST.portfolio, {
            //     state: { scrollToBottom: true },
            //   })
            // }
            style={{ cursor: "pointer" }}
          >
            {t("manage")} <img src={Open} alt="open" />
          </span>
        )}
      </div>
    );
  } else if (props.type === "performance") {
    return (
      <div className="balance-widget performance-widget">
        <span>
          {symbol?.code} {t("assets")}
        </span>

        <p>
          {props.data.amount} {symbol?.symbol}
        </p>

        <div className="performance-widget-pnl">
          <span
            style={{ color: props.data.allTime.isUp ? "#38af6c" : "#ff2c20" }}
          >
            {t("allTime")} P&L:{" "}
            {!props.data.allTime.hidden && (props.data.allTime.isUp ? "+" : "")}
            {props.data.allTime.amount}
            {symbol?.symbol} {/* /{" "} */}
            {/* {!props.data.allTime.hidden && (props.data.allTime.isUp ? "+" : "")}
            {props.data.allTime.percent}% */}
          </span>
        </div>
      </div>
    );
  } else if (props.type === "total") {
    return (
      <div className="balance-widget total-widget" onClick={props.data.onClick}>
        <span>{t("totalIn")}</span>

        <p>
          {props.data.amount} {symbol?.symbol}
        </p>

        <button className="total-widget-dropdown">
          {symbol?.code} <ChevronDownIcon aria-hidden />
        </button>

        {/* {props.data.coupon ? (
          <span
            onClick={() => navigate(PATH_LIST.portfolio)}
            style={{ cursor: "pointer" }}
          >
            + {props.data.coupon.amount}
            {symbol?.symbol} {props.data.coupon.date}
          </span>
        ) : props.data.type === "performance" ? (
          <span
            onClick={(e) => {
              e.stopPropagation();
              navigate(PATH_LIST.portfolio);
            }}
            style={{ cursor: "pointer" }}
          >
            {t("goToPortfolio")}
            <img src={Open} alt="open" />
          </span>
        ) : (
          <span
            onClick={(e) => {
              e.stopPropagation();
              navigate(PATH_LIST.portfolio, {
                state: { scrollToBottom: true },
              });
            }}
            style={{ cursor: "pointer" }}
          >
            {t("manage")}
            <img src={Open} alt="open" />
          </span>
        )} */}
      </div>
    );
  } else {
    return null;
  }
};

export default BalanceWidget;

type EmptyWidgetProps = {
  type: "balance" | "balanceSecond" | "assets";
  onClick?: () => void;
};

export const EmptyBalanceWidget: FC<EmptyWidgetProps> = ({ type, onClick }) => {
  const { t } = useTranslation("app");
  const navigate = useNavigate();
  const subAccount = useSubAccount();

  return (
    <div
      className="balance-widget"
      style={{
        cursor: "pointer",
      }}
      onClick={() => {
        if (!subAccount) navigate(PATH_LIST.deposit);
      }}
    >
      {!subAccount && (
        <TopUpIcon className="balance-widget-top-up" role="button" aria-label={t("topUpAccount")} />
      )}

      <span
        onClick={(e) => {
          e.stopPropagation();
        }}
      >
        {t("availableBalance")}
      </span>

      <p
        onClick={(e) => {
          e.stopPropagation();
        }}
      >
        0.00$
      </p>

      {!subAccount && (
        <span style={{ cursor: "pointer" }}>
          {type === "balance" ? t("topUpAccount") : t("goToMarket")}
          <img src={Open} alt="open" />
        </span>
      )}
    </div>
  );
};

// export const EmptyBalanceWidget: FC<EmptyWidgetProps> = ({ type, onClick }) => {
//   const { t } = useTranslation("app");
//   const navigate = useNavigate();
//   const { status } = useVerificationNavigation();

//   return (
//     <div
//       className="empty-balance-widget"
//       onClick={() =>
//         !status
//           ? navigate(type !== "assets" ? PATH_LIST.deposit : PATH_LIST.market)
//           : onClick?.()
//       }
//     >
//       <img
//         className="empty-balance-widget_wallet"
//         src={
//           type === "balance"
//             ? Wallet
//             : type === "balanceSecond"
//             ? AddCurrency
//             : AddPortfolio
//         }
//         alt="wallet"
//       />
//       <div>
//         <p>
//           {type === "balance"
//             ? t("noFundsYet")
//             : type === "balanceSecond"
//             ? t("otherCurrency")
//             : t("portfolioEmpty")}
//         </p>
//         <button>
//           {type === "balance" && <img src={Plus} alt="plus" />}
//           {type === "balance"
//             ? t("topUpAccount")
//             : type === "balanceSecond"
//             ? t("addFunds")
//             : t("goToMarket")}
//         </button>
//       </div>
//     </div>
//   );
// };
